import FormGroup from '../FormGroup';
import classNames from 'classnames/bind';
import styles from './Form.module.scss';

const cx = classNames.bind(styles);

function ProjectTypeForm({ keyForm, titleBtn = 'Submit', data = {}, handleSubmit = () => {}, fileInputRef }) {
  return (
    <form className={cx('create-project-type')} key={keyForm} encType="multipart/form-data" onSubmit={handleSubmit}>
      <FormGroup title="Tên loại dự án" name="name" value={data?.name} placeholder="Project Type Name" />
      <button type="submit">{titleBtn}</button>
    </form>
  );
}

export default ProjectTypeForm;